import { Dialog } from "primereact/dialog";
import { useState } from "react";
import Edit from "../../../../Utils/UserModal/UserModal";
export default function EditUser() {
  const [open, setOpen] = useState(false);

  const OpenEdit = () => {
    setOpen(true);
  };
  const CloseEdit = () => {
    setOpen(false);
  };

  window.userModalOpen = OpenEdit;
  window.userModalClose = CloseEdit;

  return (
    <div>
      <Dialog
        visible={open}
        closeOnEscape
        closeIcon
        onHide={CloseEdit}
        id="modal"
        position="center"
        transitionOptions={false}
        focusOnShow={false}
      >
        <Edit user_id={window.user_id} close={CloseEdit} />
      </Dialog>
    </div>
  );
}
